import { FormControl, MenuItem, Select } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import React, { useState } from 'react';
import { ProgressionListContent } from '@/components/chord_progression/converter/progression_list/ProgressionListContent';
import { ProgressionListLabel } from '@/components/chord_progression/converter/progression_list/ProgressionListLabel';
import { Progression } from '@/components/chord_progression/converter/types';
import * as Chord from '@/lib/chord';
import { keys } from '@/lib/key';

type SelectedKeyProgressionListState = {
  phraseKey: string;
};

export const SelectedKeyProgressionList = (props: {
  degreeProgressions: Progression[];
}) => {
  const [state, setState] = useState<SelectedKeyProgressionListState>({
    phraseKey: 'C',
  });

  const handleChange = (e: SelectChangeEvent) => {
    setState({ phraseKey: e.target.value });
  };

  const selectedKeyProgressions = convertToAlphabet(
    state.phraseKey,
    props.degreeProgressions
  );

  return (
    <Stack spacing={0.5}>
      <Stack direction={'row'} alignItems="center">
        <ProgressionListLabel>{'キー'}</ProgressionListLabel>
        <FormControl variant="standard" sx={{ mx: 1 }}>
          <Select value={state.phraseKey} onChange={handleChange}>
            {keys.map((phraseKey) => {
              return (
                <MenuItem key={phraseKey} value={phraseKey}>
                  {phraseKey}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <ProgressionListLabel>{'に変換すると'}</ProgressionListLabel>
      </Stack>
      <ProgressionListContent progressions={selectedKeyProgressions} />
    </Stack>
  );
};

const convertToAlphabet = (
  phraseKey: string,
  degreeProgressions: Progression[]
): Progression[] => {
  return degreeProgressions.map((progression) => {
    if (progression.type !== 'chords') {
      return progression;
    }

    const alphabetChords = progression.value.map((degreeChord) => {
      return Chord.convertToAlphabet(phraseKey, degreeChord);
    });

    return { ...progression, value: alphabetChords };
  });
};
